import React, {useEffect, useRef, useState} from 'react';
import styled from '@emotion/styled'
import FooterCommon from '../../../component/common/footer_common';
import ButtonScale from '../../../component/button/button_scale';
import setMinHeightByScreen from '../../../component/script/set_minheight_by_screen';
import axios from 'axios';
import ReactGA from 'react-ga4';
import { Helmet } from 'react-helmet-async';

const MinesweeperWrapper = styled.main`
    display: flex;
    flex-flow: column;
    >section {
        display: flex;
        flex-flow: column;
        width: 100%;
        flex: 1 0 auto;
        max-width: 360px;
        box-sizing: border-box;
        padding: 50px 20px;
        margin: 0 auto;
        text-align: center;
        &.start {
            justify-content: center;
            gap: 50px;
            article {
                flex: none;
                margin: 0;
                height: auto;
                min-height: auto;
            }
            nav {
                min-height: auto;
            }
        }
        > header {
            h1 {
                img {
                    display: block;
                    width: 100%;
                    max-width: 200px;
                    margin: 0 auto;
                }
            }
        }
        > article {
            min-height: 270px;
            margin-top: 50px;
            margin-bottom: auto;
            h2 {
                font-weight: 700;
                margin-bottom: 50px;
            }
            .strong {
                font-weight: 700;
            }
            .wonki {
                .hover {
                    display: none;
                }
                &:hover {
                    .normal {
                        display: none;
                    }
                    .hover {
                        display: inline;
                    }
                }
            }
            .please {
                display: inline-flex;
                margin-top: 25px;
                font-size: 18px;
                font-weight: 700;
                background: linear-gradient(0deg, rgba(206,210,245,1) 0%, rgba(206,210,245,1) 50%, rgba(255,255,255,0) 50%, rgba(255,255,255,0) 100%);
            }
            .result {
                margin-top: 25px;
            }
        }

        > nav {
            display: flex;
            flex-flow: column;
            justify-content: flex-end;
            min-height: 135px;
            align-items: center;
            &.nav-select{
                flex-flow: row;
                justify-content: space-between;
            }
            
            button{
                display: inline-flex;
                align-items: center;
                font-size: 15px;
                justify-content: center;
                background-color: transparent;
                font-weight: 300;
                font-size: 15px;
                padding: 14.5px 25px;
                border-radius: 9999px;
                font-weight: 700;
                box-shadow: -2px -2px 5px 0px rgba(255, 255, 255, 0.75), 2px 2px 5px 0px rgba(0, 0, 0, 0.05);
                color: var(--color-blue-900);
                &.on,&:hover {
                    box-shadow: -2px -2px 10px 0px rgba(255, 255, 255, 0.75) inset, 2px 2px 10px 0px rgba(0, 0, 0, 0.05) inset;
                }
                &.button-select {
                    display: flex;
                    flex-flow: column;
                    width: 100%;
                    max-width: 135px;
                    aspect-ratio: 1/1;
                    color: var(--color-black-200);
                    img {
                        margin-bottom: 5px;
                    }
                }
            }
        }
    }
`

const STRING_INVALID_USER = "invalid_user_data_error"

const HOSTNAME = "maple-frieza.com"

const Minesweeper = ()=>{
    const [scene, setscene] = useState(null)

    const [numRound, setNumRound] = useState(null)

    const [roundImage, setRoundImage] = useState(null)

    const [charactorName, setCharactorName] = useState(null);

    const [charactorGender, setCharactorGender] = useState(null);

    const [scale, setScale] = useState(false)

    const minesweeperWrapperRef = useRef(null);

    const registerUser = async () => {
        try {
            const response = await axios.get(`https://${HOSTNAME}/api/schrodinger/register`, {
                withCredentials: true, // equivalent to 'credentials: 'include''
            });
    
            const data = response.data;
    
            if (data.message === "register_success") {
                return "register_success";
            } else { 
                alert("error");
            }
        } catch (error) {
            console.error('Error registering user:', error);
        }
    };

    const getStage = async () => {
        try {
            const response = await axios.get(`https://${HOSTNAME}/api/schrodinger/get-stage`, {
                withCredentials: true,
            });
    
            const data = response.data;

            if (data.error) {
                if (data.error === STRING_INVALID_USER) {
                    const responseRegisterUser = await registerUser();
    
                    if (responseRegisterUser === "register_success") {
                        await getStage();
                    }
                } else {
                    alert("error");
                }
            }
            if(data.stageAllClear === true){
                setscene("allClear")
                setNumRound(data.roundNum)
            } else {
                setRoundImage(data.charactor.charactorImage)
                setNumRound(data.roundNum)
                setscene("round")
            }
            return data;

        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const getAnswer = async (gender)=>{
        try {
            const response = await axios.get(`https://${HOSTNAME}/api/schrodinger/answer/${gender}`, {
                withCredentials: true,
            });
    
            const data = response.data;
    
            if (data.error) {
                if(data.error === "STRING_INVALID_USER"){
                    alert(data.error)
                } else {
                    alert(`에러가 발생하여 첫 화면으로 돌아갑니다. 진행한 데이터는 저장됩니다. (${data.error})`)
                    window.location.href="https://maple-frieza.com/game/minesweeper";
                }
            }
            if(data.answer) {
                if(data.charactor){
                    setCharactorGender(data.charactor.charactorGender)
                    setCharactorName(data.charactor.charactorName)
                }
                if(data.answer === "correct") {
                    setscene("resultCorrect")
                } else if (data.answer === "wrong") {
                    setscene("resultWrong")
                }
            }
            return data;
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
  

    useEffect(
        ()=>{
            if(window.location.href === "https://frieza.gabia.io/game/minesweeper/" || window.location.href === "http://maple-frieza.com/game/minesweeper/") {
                window.location.href="https://maple-frieza.com/game/minesweeper";
            }
            ReactGA.set({
                eventCategory: "너의 선택"
            });
            ReactGA.send("pageview");
            setMinHeightByScreen(minesweeperWrapperRef)
            setscene("start")
        },[]
    )

    return(
        <MinesweeperWrapper ref={minesweeperWrapperRef}>
            <Helmet>
                <title>거짓으로 뒤덮인 메이플월드를 너의 선택으로 구해줘!!</title>
                <meta property="og:title" content="거짓으로 뒤덮인 메이플월드를 너의 선택으로 구해줘!!"/>
                <meta
                    name="description"
                    content="메이플스토리 캐릭터를 검색하여 전투력, 능력치, 장비 아이템 등을 확인해보세요."
                />
                <meta 
                    name="keyword"
                    content="추리게임, 추리, 게임, 너의 선택"
                />
                <meta property="og:image" content="/image/og/og_minesweeper.png" />
            </Helmet>
            <section className={scene}>
                <header>
                    <h1>
                        <img src="/image/logo/title_minesweeper.png" alt="거짓으로 뒤덮인 메이플월드를 너의 선택으로 구해줘!!" />
                    </h1>
                </header>
                {
                    scene === "start"?
                    <>
                        <article>
                            <p>
                                어떤 
                                <span className="wonki strong">
                                    <span className="normal">요정</span>
                                    <span className="hover">웡키</span>
                                </span>의 힘에 의해 메이플 월드 주민의 성별을<br/>
                                분간하는 것이 힘들어져 <span className="strong">봄</span>이 찾아오지 않고<br/>
                                <span className="strong">여우</span>의 개체 수와 <span className="strong">계란</span>값이 폭등하고ㅠㅠㅠ!!<br/>
                                <span className="strong">개구리</span>가 <span className="strong">두꺼비</span>로 변하고 있ㅇㅓ요..
                            </p>
                            <p className="please">
                                용사님께서 도와주세요!!!(절박)
                            </p>
                        </article>
                        <nav>
                            <button onClick={()=>{
                                    getStage()
                                }}>
                                시작하기
                            </button>
                        </nav>
                    </>:null
                }
                {
                    scene === "round"?
                    <>
                        <article>
                            <h2>ROUND {numRound}</h2>
                            <ButtonScale setScale={setScale} scale={scale}>
                                <img 
                                    src={roundImage}
                                    alt="캐릭터"
                                />
                            </ButtonScale>    
                        </article>
                        <nav className="nav-select">
                            <button className="button-select" onClick={()=>{
                                getAnswer("female")
                                
                            }}>
                                <img src="/image/icon/icon_female_fill_red.svg" alt="" />
                                여캐
                            </button>
                            <button className="button-select" onClick={()=>{
                                getAnswer("male")
                            }}>
                                <img src="/image/icon/icon_male_fill_blue.svg" alt="" />
                                남캐
                            </button>
                        </nav>
                    </>:null
                }
                {
                    scene === "resultWrong"?
                    <>
                        <article>
                            <h2>ROUND {numRound}</h2>
                            <ButtonScale setScale={setScale} scale={scale}>
                                <a href={`/charactor-info/${charactorName}`} target="_blank" rel="noreferrer">
                                    <img 
                                        src={roundImage}
                                        alt="캐릭터"
                                    />
                                </a>
                            </ButtonScale>    
                            <a href={`/charactor-info/${charactorName}`} target="_blank" rel="noreferrer">
                                <p>{charactorName}</p>
                            </a>
                            <p className="result">
                                틀렸습니다...
                                <br/>
                                <span className="strong">{charactorGender}캐</span> 였네요.
                            </p>
                        </article>
                        
                        <nav>
                            <button onClick={()=>{
                                    getStage()
                                }}>
                                다시하기
                            </button>
                        </nav>
                    </>:null
                }
                {
                    scene === "resultCorrect"?
                    <>
                        <article>
                            <h2>ROUND {numRound}</h2>
                            <ButtonScale setScale={setScale} scale={scale}>
                                <a href={`/charactor-info/${charactorName}`} target="_blank" rel="noreferrer">
                                    <img 
                                        src={roundImage}
                                        alt="캐릭터"
                                    />
                                </a>
                            </ButtonScale>                       
                            <a href={`/charactor-info/${charactorName}`} target="_blank" rel="noreferrer">
                                <p>{charactorName}</p>
                            </a>
                            <p className="result">
                                정답입니다!
                            </p>
                        </article>
                        
                        <nav>
                            <button onClick={()=>{
                                    getStage()
                                }}>
                                다음 선택으로
                            </button>
                        </nav>
                    </>:null
                }
                {
                    scene === "allClear"?
                    <>
                        <article>
                            <h2>ALL CLEAR!!</h2>
                            <p>축하합니다!<br/>게임을 열심히 즐겨주셔서 정말로 감사드립니다.</p>
                            <p>{numRound} 개의 캐릭터의 성별을 감별하셨군요!</p>
                        </article>
                    </>
                    :null
                }


            </section>
            <FooterCommon/>
        </MinesweeperWrapper>
    )

}

export default Minesweeper;